<template>
  <v-card
    :flat="isFlat"
    class="py-3"
  >
    <form-group title="Análise">
      <v-row class="pb-6">
        <v-col cols="12">
          <analysis-table-actions
            :loading="isLoading"
            @success="reload()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <form-group class="ma-0 pa-0 mb-3">
            <client-from-sgv-chip
              v-model="isFromSgv"
              :loading="isLoading"
            />
          </form-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <client-data-register-view
            id="input:UserValidationDataAnalyses"
            v-model="payload"
            :loading="isLoading"
          />
        </v-col>
      </v-row>
    </form-group>
  </v-card>
</template>

<script>
import ClientDataRegisterView from 'Modules/contacard/analysisTable/components/dataViews/ClientDataRegisterView.vue';
import AnalysisCardMixin from 'Modules/contacard/analysisTable/components/cards/AnalysisCardMixin';
import AnalysisTableActions from 'Modules/contacard/analysisTable/components/buttons/AnalysisTableActions.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ClientRequest from '@/app/client/ClientRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import StorageMixin from '@/app/arch/mixins/StorageMixin';
import ClientFromSgvChip from '../chips/ClientFromSgvChip.vue';

export default {
  name: 'AnalysisInfoCard',
  components: {
    ClientDataRegisterView,
    AnalysisTableActions,
    ClientFromSgvChip,
    FormGroup,
  },
  mixins: [AnalysisCardMixin, ServiceMixin, StorageMixin],
  data: () => ({
    clientLoading: false,
    requestClass: ClientRequest,
  }),
  computed: {
    getReload() {
      return this.analysisTable.page.reloadInfo;
    },
    isFromSgv() {
      return this.analysisTable.client.importadoSgv;
    },
    isChild() {
      return this.analysisTable.cardFlat;
    },
    clientId() {
      return this.analysisTable.client.id;
    },
  },
  methods: {
    reload() {
      this.getReload();
      this.successCallback();
    },
    successCallback() {
      if (this.isChild) {
        this.$root.$emit('reload-analysisTable-father', true);
      } else {
        this.reloadClient();
      }
    },
    reloadClient() {
      this.handleClientLoading();
      this.getClient();
    },
    handleClientLoading() {
      this.handleClientInfo({
        loading: !this.clientLoading,
      });
    },
    getClient() {
      this.callService(
        this.requestClass.get(
          this.clientId,
        ),
        this.clientConfig,
        this.refreshClient,
      );
    },
    refreshClient(response) {
      this.handleClientLoading();
      if (this.hasData(response)) {
        const { data } = response;
        this.storage.save('@clientTable', data);
        this.handleClient(data);
      }
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          page: {
            reloadInfo: () => {},
          },
          client: {
            importadoSgv: '',
            id: '',
          },
          cardFlat: '',
        };
      },
    },
    handleClientInfo: {
      default() {
        return (v) => v;
      },
    },
    handleClient: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
